import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getSendIvitation = async (): Promise<
  GetSendIvitationType[] | { message: string }
> => {
  try {
    const result = await apiService.get('central/usuario/all')
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const postSendIvitation = async (
  usuarioConviteRequestDTO: {},
  tenantId: string
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.post(
      `central/usuario/organizacao/${tenantId}/convite`,
      {
        ...usuarioConviteRequestDTO,
      }
    )
    if (result.status === 200) {
      return { info: 'Email enviado com sucesso' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
